import { useState } from 'react';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import { objectToFormData } from '../../../../utils/utils';

const useUploadReport = () => {
    const [uploading, setUploading] = useState(false);

    const uploadReport = async ({reqId, testId = null, reportFile}) => {
        setUploading(true);
        const filename = reportFile.name.replace(/\.[^/.]+$/, '').replace(/[^a-zA-Z0-9\s]/g, '');
        const payload = { report: reportFile, name: filename, reqId };
        if (testId) {
            payload.testId = testId;
        }
        const formData = objectToFormData(payload);
        const url = APIUtils.getAdminAPIEndpoint('vendor:upload-report');
        const {err, res} = await httpClient.post(url, formData).then(res => ({err: null, res: res.data})).catch(err => ({err, res: null}));
        setUploading(false);
        return { err, res };
    };

    return { uploading, uploadReport };
};

export default useUploadReport;